import { CSSObject } from "@emotion/react";

export const ulCss: CSSObject = {
  margin: 0,
  padding: 0,
  listStyle: "none",
};

export const checkboxCss: CSSObject = {
  marginBottom: "8px",
};
